import React, { useContext, useState, useEffect } from "react";
import { Row, Col, Input, Button, Form } from "antd";
import { Link, useHistory } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { AppContext } from "../../appRouter";
import { connect } from "react-redux";
import { loginUser, oAuth2 } from "../../redux/actions/authentication";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginCredentialsSchema } from "../validattion";

const Login = (props) => {
  const { handleIsLoggedIn, clearData } = useContext(AppContext);

  let history = useHistory();
  let { loginUser } = props;
  const [loading, setLoading] = useState(false);

  // --- clear all storages set already here ---
  useEffect(() => {
    clearData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Form
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginCredentialsSchema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    let res = await loginUser(data);
    if (res.success) {
      toast("Successfully Logged In..redirecting to dashboard", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      handleIsLoggedIn(true);
      if (res.is_staff) {
        setTimeout(() => {
          history.push("/admin/dashboard");
        }, 1000);
      } else {
        setTimeout(() => {
          history.push("/dashboard");
        }, 1000);
      }
    } else {
      // this backend team confused the auth endpoints
      if (
        res.message ===
        "non_field_errors: Unable to log in with provided credentials. "
      ) {
        toast.error("Unable to log in with provided credentials.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("An unexpected error occurred. Kindly try again, please.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      handleIsLoggedIn(false);
      setLoading(false);
    }
  };
  return (
    <>
      {/*<ToastContainer*/}
      {/*  position="top-right"*/}
      {/*  autoClose={5000}*/}
      {/*  hideProgressBar={false}*/}
      {/*  newestOnTop*/}
      {/*  closeOnClick*/}
      {/*  rtl={false}*/}
      {/*  pauseOnFocusLoss*/}
      {/*  draggable*/}
      {/*  pauseOnHover*/}
      {/*/>*/}
      <AuthLayout
        fadeName="fade-right"
        pageTitle="Login"
        // googleLabel="Sign In"
        // oAuth2={oAuth2}
      >
        <Form onFinish={handleSubmit(onSubmit)} autoComplete="off">
          <Row gutter={24}>
            <Col xs={24} xl={24} lg={24}>
              <div className="form-group">
                <label>Email Address</label>
                <Controller
                  name="email"
                  control={control}
                  defaultValue=""
                  render={({ field }) => <Input {...field} />}
                />
                {errors.email && (
                  <span className="error">Email Address is required</span>
                )}
              </div>
            </Col>
            <Col xs={24} xl={24} lg={24}>
              <div className="form-group">
                <label>Password</label>
                <Controller
                  name="password"
                  control={control}
                  defaultValue=""
                  render={({ field }) => <Input.Password {...field} />}
                />
                {errors.password && (
                  <span className="error">Password is required</span>
                )}
              </div>

              <p className="p-pwd">
                <Link to="/forgot-password">Forgot Password?</Link>
              </p>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={24} xl={24} lg={24}>
              <Button loading={loading} block htmlType="submit" type="primary">
                {loading ? "Authenticating..." : "LOGIN"}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col xs={24} xl={24} lg={24}>
              <p className="register">
                Don't have account? <Link to="/auth/register">Get Started</Link>
              </p>
            </Col>
          </Row>
        </Form>
      </AuthLayout>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auth_error: state.authReducer.auth_error,
  };
};

export default connect(mapStateToProps, { loginUser, oAuth2 })(Login);
